import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { Container } from 'common/components';
import { WindowTypes, selectWindowType } from 'store/pageStore';
import { checkScreenType } from 'utils';
import { orderStepsContent } from 'data';
import { Step } from '../step';
import { stepsHeaderStyles } from './styles';

export const StepsContainer = () => {
	const currentWindowType = useSelector(selectWindowType);
	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);
	return (
		<Container>
			<Typography
				className={stepsHeaderStyles}
				variant={isMobile ? 'h2' : 'h1'}
				as="h2"
				overrideStyles={false}
			>
				Как заказать колеровку
			</Typography>
			{orderStepsContent.map((step, index) => (
				<Step {...step} index={index + 1} />
			))}
		</Container>
	);
};
